import React from "react";
//import RowItem from "../../utils/smu-table/parts/RowItem";
//import CellItem from "../../utils/smu-table/parts/CellItem";
//import SmuTable from "../../utils/smu-table/SmuTable";
import SmuButton from "../../utils/smu-button/SmuButton";
import { Card } from "react-bootstrap";
import { IconDownload } from "../../icons/Icon";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import moment from "moment";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { downloadFile } from "../../api/files";
import SmuTable from "../../utils/smu-table/SmuTable";
import { useState } from "react";
import { useMemo } from "react";

const RecentFilesTable = ({ files }) => {
  const [dowloading, setDownloading] = useState(null);

  const handleDate = (_date) => {
    return moment(_date).format("DD-MM-YYYY HH:mm");
  };

  const download = (category, fileId) => {
    setDownloading(fileId);
    downloadFile(category, fileId)
      .then(({ data, error }) => {
        console.log("data", data)
        if (!!error) throw new Error(error?.message);

        const {
          url,
          document: { filename },
        } = data;

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        alert('your file has downloaded!'); //
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setDownloading(null));
  };

  const columns = useMemo(
    () => [
      {
        name: "Titulo y Sección",
        selector: (row) => row.filename,
        sortable: true,
        cell: (row) => <div className="cell text-truncate">{row.filename}</div>,
        width: "50%",
      },
      {
        name: "Tipo documento",
        selector: (row) => row.filetype,
        sortable: true,
        cell: (row) => (
          <div className="cell text-truncate">{row.filetype}</div>
        ),
      },
      {
        name: "Fecha",
        selector: (row) => row.timestamp,
        sortable: true,
        cell: (row) => (
          <div className="cell text-truncate">{handleDate(row.created_date)}</div>
        ),
      },
      {
        name: "Descargar",
        selector: (row) => row.id,
        cell: (row) => (
          <div className="cell">
            <SmuButton
              _className="ms-auto"
              control={() => download(row.category, row.id)}
              loading={dowloading === row.id}
            >
              <IconDownload color="#33383F" />
            </SmuButton>
          </div>
        ),
        right: true,
      },
    ],
    [dowloading]
  );

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#B1E5FC" />
          <span className="fs-5 ms-3 me-auto">
            Archivos subidos recientemente
          </span>
        </div>
      </Card.Header>
      <Card.Body>
        <SmuTable columns={columns} data={files} />

        {/* <SmuTable headers={headers} hiddenSearch={true}>
          {files.map((file) => (
            <RowItem key={file.uuid}>
              <CellItem _className="cell">
                <div className="w-100">
                  <div className="text-truncate">{file.filename}</div>
                  
                </div>
              </CellItem>
              <CellItem _className="cell text-truncate">
                {handleDate(file.timestamp)}
              </CellItem>
              <CellItem _className="cell">
                <SmuButton
                  _className="mx-auto"
                  control={() => download(file.category, file.uuid)}
                >
                  <IconDownload color="#33383F" />
                </SmuButton>
              </CellItem>
            </RowItem>
          ))}
        </SmuTable> */}
      </Card.Body>
    </Card>
  );
};

export default RecentFilesTable;
